<template>
  <section>
      <Loading v-if="loading" />
      <div
        v-else
        class="row no-gutters py-5"
      >
        <div class="col-12 col-lg-10 offset-lg-1">
          <div v-if="supplier.description" class="row no-gutters mb-3">
            <div class="col col-lg-8 px-3 px-lg-0">
              <strong>{{ supplier.description }}</strong>
            </div>
          </div>
          <div class="row no-gutters w-100 mb-3 justify-content-end">
            <b-link
              v-if="supplier.website_url"
              :href="supplier.website_url"
              class="red-link px-3 px-lg-0"
            >
              <span v-if="supplier.website_name" class="mr-3">{{ supplier.website_name }}</span>
              <span v-else class="mr-3">{{ $t('goTo') }} {{ supplier.supplier_name }}</span>
              <icon-navigate />
            </b-link>
          </div>
          <div class="row no-gutters">
            <training-card
              v-for="item in trainings.data.trainingInfo"
              :key="item.entity_id"
              :trainingInfo="item"
            />
          </div>
        </div>
      </div>
  </section>
</template>

<script>
import gql from 'graphql-tag'
import { GET_TRAININGS_BY_SUPPLIER } from '../../../graphql/queries/suppliers'
import TrainingCard from './TrainingCard.vue'
import Loading from '../Loading.vue'
import IconNavigate from '../../icons/IconNavigate.vue'

export default {
  components: { TrainingCard, Loading, IconNavigate },
  name: 'SupplierCard',
  props: {
    supplier: {
      default: 'all'
    }
  },
  data () {
    return {
      loading: true,
      lang: this.$store.getters.getLang
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    getLangForGraphQL () {
      switch (this.lang) {
        case 'fr':
          return 'fr-CA'
        default:
          return 'en-CA'
      }
    },

    async loadData () {
      try {
        const query = gql`
        query {
          ${GET_TRAININGS_BY_SUPPLIER
    .replace('$lang', this.lang)
    // eslint-disable-next-line camelcase
    .replace('$supplier_id', this.supplier.entity_id)
}}`
        this.trainings = await this.$apollo.query({ query })
        // After the loader completes, update the props and loading state
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    }
  }
}

</script>

<style lang="scss">
.red-link {
  color: $red;
  font-weight: bold;
  font-size: 1.6rem;
}
</style>